<template>
  <div id="centerDiv">
    <div id="mapa" class="map"></div>
    <div id="mapb" class="map"></div>
  </div>
  <div id="timeline"></div>
  <div id="timeline2"></div>
</template>

<script setup>
//props
import { onMounted, reactive } from "vue";
import global from "../components/global.vue";
import { tiledMapLayer } from "esri-leaflet";
import * as echarts from "echarts/core";
import { BarChart, LineChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DatasetComponent,
  // 引入时间轴组件
  TimelineComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

// 注册组件（必须包含 TimelineComponent）
echarts.use([
  BarChart,
  LineChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DatasetComponent,
  TimelineComponent, // 时间轴组件
  CanvasRenderer,
]);
var timelinechart, timelinechart2;
var emphasiscolor = "#03f6f9";
var emphasis_style = {
  color: emphasiscolor,
  borderColor: "rgba(3,246,249, 0.5)",
};

let map, map2;
//定义国家2000坐标系
L.CRS.EPSG4490 = L.extend({}, L.CRS, {
  code: "EPSG:4490",
  projection: L.Projection.LonLat,
  transformation: new L.Transformation(1 / 360, 0.5, -1 / 360, 0.5),
  wrapLng: [-180, 180],
});

onMounted(() => {
  var timedata = global.yx_array;
  timelinechart = echarts.init(document.getElementById("timeline"));
  timelinechart2 = echarts.init(document.getElementById("timeline2"));
  var timeline_option = {
    baseOption: {
      timeline: {
        axisType: "category",
        autoPlay: false,
        currentIndex: timedata.length - 1,
        playInterval: 5000,
        orient: "horizontal",
        inverse: true,
        rewind: true,
        top: 1,
        bottom: 1,
        left: 1,
        right: 1,
        label: {
          //标签
          color: "#c3d4fd",
          emphasis: emphasis_style,
        },
        lineStyle: {
          //轴线
          color: "#c3d4fd",
        },
        itemStyle: {
          //线上点鼠标移上去后
          emphasis: emphasis_style,
        },
        checkpointStyle: emphasis_style, //当前点
        controlStyle: {
          //控制按钮
          normal: {
            color: "#c3d4fd",
            borderColor: "rgba(195,212,253, 0.5)",
          },
          emphasis: emphasis_style,
        },
        data: timedata,
      },
      backgroundColor: "rgba(25, 24, 52, 0.7)",
    },
  };
  var timeline_option2 = {
    baseOption: {
      timeline: {
        axisType: "category",
        autoPlay: false,
        currentIndex: 0,
        playInterval: 5000,
        orient: "horizontal",
        inverse: true,
        rewind: true,
        top: 1,
        bottom: 1,
        left: 1,
        right: 1,
        label: {
          //标签
          color: "#c3d4fd",
          emphasis: emphasis_style,
        },
        lineStyle: {
          //轴线
          color: "#c3d4fd",
        },
        itemStyle: {
          //线上点鼠标移上去后
          emphasis: emphasis_style,
        },
        checkpointStyle: emphasis_style, //当前点
        controlStyle: {
          //控制按钮
          normal: {
            color: "#c3d4fd",
            borderColor: "rgba(195,212,253, 0.5)",
          },
          emphasis: emphasis_style,
        },
        data: timedata,
      },
      backgroundColor: "rgba(25, 24, 52, 0.7)",
    },
  };

  timelinechart.setOption(timeline_option);
  timelinechart2.setOption(timeline_option2);
  map = L.map("mapa", {
    center: {
      lon: global.centerX,
      lat: global.centerY,
    },
    zoom: 9,
    crs: L.CRS.EPSG4326,
    attributionControl: false,
  });
  map2 = L.map("mapb", {
    center: {
      lon: global.centerX,
      lat: global.centerY,
    },
    zoom: 9,
    crs: L.CRS.EPSG4326,
    attributionControl: false,
  });
  mapType(map, timedata[timedata.length - 1]);
  mapType(map2, timedata[0]);
  //节点改变事件，加载不同年份的数据
  timelinechart.on("timelinechanged", function (param) {
    var currentIndex = param.currentIndex;
    var year = timedata[currentIndex];
    mapType(map, year);
  });
  timelinechart2.on("timelinechanged", function (param) {
    var currentIndex = param.currentIndex;
    var year = timedata[currentIndex];
    mapType(map2, year);
  });
  //左右联动
  map.on({
    drag: maplink,
    zoom: maplink,
  });
  map2.on({
    drag: maplink,
    zoom: maplink,
  });
});

function mapType(thismap, year) {
  //清空缓存图层
  var tilepane = thismap.getPane("tilePane");
  tilepane.innerHTML = "";
  thismap.eachLayer(function (layer) {
    if (layer instanceof L.tileLayer || layer instanceof tiledMapLayer) {
      thismap.removeLayer(layer);
    }
  });
  var yxurl = global.mapurl + "jyyx" + year + "/MapServer";

  var yxscyImgm = tiledMapLayer({
    url: yxurl,
    token: global.tk,
    maxZoom: 19,
    minZoom: 10,
  }); //苏测院影像底图
  thismap.addLayer(yxscyImgm);

  //境界图层
  var jjLayer = tiledMapLayer({
    url: global.jj,
    token: global.tk,
    maxZoom: 19,
    minZoom: 10,
  });
  thismap.addLayer(jjLayer);
}

function maplink(e) {
  var _this = this;
  map.setView(_this.getCenter(), _this.getZoom());
  map2.setView(_this.getCenter(), _this.getZoom());
}
</script>

<style>
#centerDiv {
  height: 100%;
  width: 100%;
}

#mapa {
  position: absolute;
  height: 100%;
  width: 50%;
  border: 2px solid #6699ff;
}

#mapb {
  position: absolute;
  height: 100%;
  width: 50%;
  left: 50%;

  border: 2px solid #6699ff;
}

#timeline {
  position: absolute;
  z-index: 999;
  width: 550px;
  height: 66px;
  bottom: 30px;
  border: 1px solid rgba(107, 243, 202, 0.4);
  border-radius: 5px;
  right: 65%;
}

#timeline2 {
  position: absolute;
  z-index: 999;
  width: 550px;
  height: 66px;
  bottom: 30px;
  border: 1px solid rgba(25, 186, 139, 0.4);
  border-radius: 5px;
  right: 13%;
}

#sth {
  position: absolute;
  /* bottom: 25px; */
  bottom: 60px;
  background-color: transparent;
  left: 5px;
  z-index: 999;
  height: 18px;
  text-shadow: #edeaea 1px 0 0, #edeaea 0 1px 0, #edeaea -1px 0 0,
    #edeaea 0 -1px 0;
}

#src {
  position: absolute;
  bottom: 5px;
  right: 55px;
  margin-right: 0px;
  background-color: transparent;
  z-index: 999;
  height: 18px;
  text-shadow: #edeaea 1px 0 0, #edeaea 0 1px 0, #edeaea -1px 0 0,
    #edeaea 0 -1px 0;
}
</style>